import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';
import { motion } from 'framer-motion';

export const Container = styled.div`
  grid-area: chart;
  display: flex;
  background-color: transparent;
  position: relative;
  height: 335px;
  margin: 30px 0 30px 0;
  overflow: hidden;
  justify-content: center;
 
    
  @media (min-width: ${breakpoints.desktop}) {
   // width: 680px;
   height: 480px;        
   background-color: transparent;
   padding: 0; 
   margin: 30px 0 30px 30px;
   overflow:hidden;
    width: 910px;
   
   .carousel .control-dots {
   margin: 0px 0 0 0;
   }
   
   .carousel .control-dots .dot {
    background-color: #a6a6a6;
    
   }
   
   .carousel .carousel-status {
   color: black;
   text-shadow: none;
   font-size: 16px;
   margin: 5px 45px 0 0;
   }
  }
  
  .rangeslider-bg {
    border: 5px red solid;
  }
`;

export const ChartContainer = styled.div`
  flex: 1;
  padding: 0px 20px 0px 20px;
  margin: 0;
  
  @media (min-width: ${breakpoints.desktop}) {
   padding: 0 40px; 
   background-color: #757575;
  }
`

export const NoDataImageWrapper = styled.img`
  object-fit: cover;
  width: 100%;
`;

export const NoDataSub = styled.p`
  font-size: 16px;
  margin: 0 15px;
`;

export const ResetButton = styled.span`
  background-color: #a41818;
  color: white;
  padding: 5px 10px;
  //position: absolute;
  display: none;
  //bottom: 20px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 25px;
  margin-left: 140px;
  float: left;
  
  @media (min-width: ${breakpoints.desktop}) {
   display: inline;
  }
  
`;

export const IconContainer = styled.span`
  margin-left: 10px;
`;

export const LoadingText = styled(motion.h2)`
  color: white;
  text-align: center;
  font-size: 22px;
  display: flex;
  justify-content: center;
`;
